import React, { Component } from 'react';
import { Grid,Row,Col,Image,Button,Panel,Modal,FormGroup,InputGroup,FormControl,ControlLabel } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom'
import './Orders.css';
import { API_ROOT, IPAY } from '../../config.js';
import spinner from '../Header/Spinner-1s-150px.svg'
import sha256 from 'crypto-js/sha256'

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderList: null,
      confirmDeleteShow: false,
      deleteId: null,
      orderIds: "",
      checkoutTotal: 0,
      userName: localStorage.getItem("userName") === null? '': localStorage.getItem("userName"),
      userEmail: localStorage.getItem("userEmail") === null? '': localStorage.getItem("userEmail"),
      userContact: localStorage.getItem("userContact") === null? '': localStorage.getItem("userContact"),
      blnuserName: null,
      blnUserEmail: null,
      blnUserContact: null,
      refNo: (Date.now().toString(36) + Math.random().toString(36).substr(2, 8)).toUpperCase(),
      currency: "MYR",
      blnRedirect: false,
      isLoading: true,
      zeroCardSaved: null,
      itemDescription: ""
    }
  }

  componentDidMount () {
    var isSingleCheckout = false
    var api = `${API_ROOT}/orders`
    if (this.props.orderid != null && this.props.orderid > 0) {
      api += `/${this.props.orderid}`
      isSingleCheckout = true
    }
    fetch(api, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })
    .then ( response => {
      if ( response.ok ) {return response.json()}
      this.setState({zeroCardSaved:this.zeroCardSaved(),isLoading:false})
    })
    .then(data => {
      var checkoutTotal = 0;
      var orderIds = '';
      var itemDescription = 'NaleyCards - '
      if (isSingleCheckout === true) {
        data = {orders:[data.orders]}
      }
      //console.log(data.orders.length)

      var orders = data.orders.map((order, index) => {
        checkoutTotal = checkoutTotal + order.total;
        orderIds = orderIds + '#' + order.order + ','
        itemDescription = itemDescription + order.card_name + ', '
        return(
          <div className="card-detail" key={order.order} total={order.total}>
            <Row>
              <Col xs={12} sm={5} md={4} lg={3}>
                <center>
                <Image src={order.small_image} responsive rounded />
                {order.card_name}
                {(order.quantity > 0 && order.order_type === 2) ? (
                  " (blank card x " + order.quantity + ") "
                ):(
                  " "
                )}
                - RM{new Intl.NumberFormat('ms-MY',{
                  minimumFractionDigits: 2
                }).format(order.total)}
                </center>
              </Col>
              <Col xs={12} sm={7} md={8} lg={9}>
                <h3>To {order.recipient}</h3>
                <h4>{order.address}<br />
                {order.postcode} {order.city} <br />
                {order.state.charAt(0).toUpperCase()}{order.state.slice(1)}</h4>
                <Link to={`/cards/${order.card_id}/orders/${order.order}`}><Button bsSize="small">Edit</Button></Link>&nbsp;
                <Button bsSize="small" onClick={(event) => this.confirmDelete(event, order.order)}>Delete</Button>&nbsp;
                { (isSingleCheckout === false && data.orders.length > 1) && (
                    <Link to={`/orders/${order.order}`}><Button bsSize="small">Checkout</Button></Link>
                )}
              </Col>
            </Row>
          </div>
        )
      })
      checkoutTotal = new Intl.NumberFormat('ms-MY',{ minimumFractionDigits: 2 }).format(checkoutTotal)
      if (isSingleCheckout === true) {
        this.props.subject(this.renderSubject(data.orders[0]))
      }
      this.setState({orderIds:orderIds})
      this.setState({checkoutTotal:checkoutTotal})
      this.setState({itemDescription:itemDescription.substring(0, itemDescription.length-2)})
      this.setState({orderList:orders,isLoading:false});
      //console.log(checkoutTotal)
    })
    .catch((error) =>{
      //console.error(error);
    })
  }

  componentWillUnmount() {
    if (this.props.subject != null) {
      this.props.subject('')
    }
  }

  renderSubject(data){
    return (
      <div>
          <Link to="/orders">Saved </Link> / {data.card_name} - RM{new Intl.NumberFormat('ms-MY',{minimumFractionDigits: 2}).format(data.total)}
      </div>
      )
  }

  confirmDelete(event, orderId) {
    event.preventDefault()
    this.setState({confirmDeleteShow:true})
    this.setState({deleteId:orderId})
    //console.log(orderId)
  }

  deleteOrder(event) {
    event.preventDefault()
    this.setState({confirmDeleteShow:false})

    if(this.state.deleteId !== null){
      fetch(`${API_ROOT}/orders/${this.state.deleteId}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        //body: JSON.stringify({})
      })
      .then ( response => {
        if ( response.ok ) {
          //update total saved at header (right top)
          this.props.savedCount(-1);

          //delete the row without query listing API
          var orderList = this.state.orderList;
          orderList.forEach((order, index) => {
            if(Number(order.key) === this.state.deleteId) {
              //console.log(order)
              this.setState({checkoutTotal:this.state.checkoutTotal - order.props.total})
              this.setState({orderIds:this.state.orderIds.replace('#' + order.key + ',', '')})
              orderList.splice(index, 1);
              this.setState({orderList:orderList})
            }
          })
          //All saved cards deleted
          if (orderList.length === 0) {
            this.setState({orderList:null, zeroCardSaved:this.zeroCardSaved()})
          }
          //console.log(this.state.orderIds)
          return response.json();
        }
      })
      .catch((error) =>{
        //console.error(error);
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const tvalue = target.type === 'checkbox' ? target.checked : target.value;
    const tname = target.id;

    this.setState({[tname]: tvalue})

    if(tname === 'userName' && tvalue.length > 0){
      if(this.state.blnUserName !== null){
        this.setState({blnUserName: null})
      }
      localStorage.setItem('userName', tvalue)
    }
    if(tname === 'userEmail' && tvalue.length > 0){
      if(this.state.blnUserEmail !== null){
        this.setState({blnUserEmail: null})
      }
      localStorage.setItem('userEmail', tvalue)
    }
    if(tname === 'userContact' && tvalue.length > 0){
      if(this.state.blnUserContact !== null){
        this.setState({blnUserContact: null})
      }
      localStorage.setItem('userContact', tvalue)
    }
  }

  handleFormSubmit(event){
    event.persist()
    event.preventDefault()

    var blnError = false;
    if(this.state.userName.length === 0){
      this.setState({blnUserName: 'error'});
      blnError = true;
    }
    if(this.state.userEmail.length === 0){
      this.setState({blnUserEmail: 'error'});
      blnError = true;
    }
    if(this.state.userContact.length === 0){
      this.setState({blnUserContact: 'error'});
      blnError = true;
    }

    if(blnError === true){
      return false;
    }

    var checkoutInfo = {}
    checkoutInfo.reference_number = this.state.refNo
    checkoutInfo.payor_name = this.state.userName
    checkoutInfo.payor_email = this.state.userEmail
    checkoutInfo.payor_contact = this.state.userContact
    checkoutInfo.payment_type = 0
    checkoutInfo.amount = 0.00

    fetch(`${API_ROOT}/precheckouts`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      },
      body: JSON.stringify(checkoutInfo),
    })
    .then ( response => {
      if ( response.ok ) {
        this.refs.ipayForm.submit()
      }
    })
    .catch((error) =>{
      console.error(error);
    })
  }

  zeroCardSaved() {
    return(
      <center>
      <h4>You {"don't"} have any cards saved.</h4><br />
      <span className="nl-button">
        <Link to="/cards"><Button bsSize="lg">Choose a card</Button></Link>
      </span>
      </center>
    )
  }

  render() {
    document.title = "Your Saved Cards - NaleyCards Malaysia"
    if (this.state.blnRedirect === true) {
      return (<Redirect to="/purchases" />)
    }
    return (
      <React.Fragment>

      <Modal show={this.state.confirmDeleteShow}>
        <Modal.Body>
          Are you sure you want to delete this saved card?<br/><br/>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={(event) => this.deleteOrder(event)}>Delete</Button>&nbsp;
          <Button onClick={() => this.setState({confirmDeleteShow:false})}>Cancel</Button>
        </Modal.Footer>
      </Modal>

      <Grid fluid>
      {this.state.isLoading === true && (
        <Row>
        <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        </Row>
      )}
      {this.state.orderList != null && (
      <Row>
        <Col xs={12} sm={7} md={8} lg={8}>
          {this.state.orderList}
        </Col>
        <Col xs={12} sm={5} md={4} lg={4}>

          <Panel bsStyle="info">
            <Panel.Heading>
              <Panel.Title>Checkout</Panel.Title>
            </Panel.Heading>

            <Panel.Body>
            <FormGroup controlId="userName" validationState={this.state.blnUserName}>
              <InputGroup>
                <InputGroup.Addon bsClass="input-group-addon addon-text">Name</InputGroup.Addon>
                <FormControl type="text" placeholder="Your name" value={this.state.userName} onChange={(event) => this.handleInputChange(event)} />
              </InputGroup>
            </FormGroup>
            <FormGroup controlId="userEmail" validationState={this.state.blnUserEmail}>
              <InputGroup>
                <InputGroup.Addon bsClass="input-group-addon addon-text">Email</InputGroup.Addon>
                <FormControl type="text" placeholder="Your email" value={this.state.userEmail} onChange={(event) => this.handleInputChange(event)} />
              </InputGroup>
            </FormGroup>
            <FormGroup controlId="userContact" validationState={this.state.blnUserContact}>
              <InputGroup>
                <InputGroup.Addon bsClass="input-group-addon addon-text">Phone no.</InputGroup.Addon>
                <FormControl type="text" placeholder="Mobile, work or home" value={this.state.userContact} onChange={(event) => this.handleInputChange(event)} />
              </InputGroup>
            </FormGroup>
            <ControlLabel>Total:</ControlLabel> RM{this.state.checkoutTotal}

            </Panel.Body>
          </Panel>

            <form action={IPAY.formAction} ref="ipayForm" method="post" onSubmit={(event) => this.handleFormSubmit(event)}>
            <input type="hidden" name="UserName" value={this.state.userName} />
            <input type="hidden" name="UserEmail" value={this.state.userEmail} />
            <input type="hidden" name="UserContact" value={this.state.userContact} />
            <input type="hidden" name="MerchantCode" value={IPAY.merchantCode} />
            <input type="hidden" name="PaymentId" value="" />
            <input type="hidden" name="RefNo" value={this.state.refNo} />
            <input type="hidden" name="Amount" value={this.state.checkoutTotal} />
            <input type="hidden" name="Currency" value={this.state.currency} />
            <input type="hidden" name="ProdDesc" value={this.state.itemDescription} />
            <input type="hidden" name="Remark" value={this.state.orderIds} />
            <input type="hidden" name="Lang" value="UTF-8" />
            <input type="hidden" name="SignatureType" value="SHA256" />
            <input type="hidden" name="Signature" value={sha256(IPAY.merchantKey + IPAY.merchantCode + this.state.refNo + this.state.checkoutTotal.toString().replace('.','').replace(',','') + this.state.currency)} />
            <input type="hidden" name="ResponseURL" value={IPAY.responseUrl} />
            <input type="hidden" name="BackendURL" value={IPAY.backendUrl} />
            </form>

            <span className="nl-button">
              <Button block bsSize="lg" onClick={(event)=>this.handleFormSubmit(event)}>
                Checkout
              </Button>
            </span>
        </Col>
      </Row>
      )}
      {this.state.zeroCardSaved}
    </Grid>
    </React.Fragment>
    );
  }
}

export default Orders
